import styled from 'styled-components'

export const ShopSection = styled.section`
  border-radius: 4px;
  border: 1px solid #D4D4D6;
  padding: 12px;
  background: #FFF;
  display: flex;
  flex-direction: column; 
`

export const Header = styled.div`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 165%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`
export const Appointment = styled.div`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 165%;
  margin-bottom: 8px;
  color: #333;
`

export const Availability = styled.span`
  font-weight: 400;
  margin-left: 8px;
`

export const ShopName = styled.span`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 165%;
  color: #333;
`
export const Rating = styled.div`
  margin: 4px 0;
  display: flex;
  align-items: center;
`
export const ShopRatingLabel = styled.span`
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin-left: 3px;
  line-height: 165%;
`

export const ShopAddress = styled.div`
  margin-bottom: 8px;
  color: #333;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
`

export const ShopMileage = styled.span`
  font-weight: 500;
`

export const WarrantyMessage = styled.div`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  color: #5C5C5C;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  border-radius: 4px;
  padding: 4px;
  background: #F4F4F4;
  margin-bottom: 16px;
  line-height: 165%;
`

export const WarrantyMessageBold = styled.span`
  font-weight: 600;
`

export const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px
`
